.kn{gap:0.125rem;}